import { styled } from '@mui/material/styles'

export const Root = styled('div')(({ theme }) => ({
  marginTop: "5px",

  [theme.breakpoints.up("sm")]: {
    marginTop: "15px",
  },
}));
